/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2022-09-26 14:16:27
 */
import TsaEnvironmentCheck from '@/components/environmentCheck/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const EnvironmentCheck = vue.extend(TsaEnvironmentCheck)
    if (!$vm) {
      $vm = new EnvironmentCheck({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const environmentCheck = {
      show (options = {}) {
        $vm.message = options.message
        $vm.show = true
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaEnvironmentCheck) {
      vue.prototype.$TsaEnvironmentCheck = environmentCheck
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/EnvironmentCheck/index.js